import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { ManagerService } from '../services/manager.service';
import { Manager } from '../models/Manager';

@Component({
  selector: 'account-menu',
  templateUrl: 'account-menu.component.html',
  styleUrls: ['account-menu.component.css']
})
export class AccountMenuComponent {

  manager!: Manager;

  constructor(private router: Router, private authService: AuthService, private managerService: ManagerService) { }

  ngOnInit() {
    this.manager = this.managerService.getLoggedUser();
  }

  logout()
  {
    this.authService.logout().subscribe(() => {});
    this.managerService.logout();
    this.router.navigate(['/login']);
  }
}
